import GalleryPaginator from "@ext/markdown/elements/gallery/print/GalleryPaginator";
import { throwIfAborted } from "@ext/print/utils/pagination/abort";
import type { PrintNodeHandler } from "@ext/print/utils/pagination/nodeHandlers";
import Paginator from "@ext/print/utils/pagination/Paginator";

const galleryHandlerFn: PrintNodeHandler["handle"] = async (node, paginator) => {
	if (node.dataset?.component !== "gallery") return false;

	new GalleryPaginator(node as HTMLDivElement, paginator).paginateNode();
	await Paginator.controlInfo.yieldTick();
	throwIfAborted(Paginator.controlInfo.signal);
	return true;
};

const galleryHandler: PrintNodeHandler = {
	handle: galleryHandlerFn,
};

export default galleryHandler;
